<div #orderHistoryTopAnchor></div>
<div class="fc-order-history-wrapper">
    <h3 class="fc-order-history-title" fc-skeleton>{{ 'ORDER_HISTORY_OVERVIEW.ORDERS_OVERVIEW' | translate }}</h3>
    <div>
        <form [formGroup]="filterForm">
            <div class="fc-order-history-filters">
                <div class="fc-order-history-filters-wrapper">
                    <form
                        class="fc-order-history-search-bar"
                        [formGroup]="searchForm"
                        [ngClass]="{ 'fc-order-history-search-bar-empty': !searchForm.controls.search.value }"
                        fc-skeleton
                    >
                        <section class="fc-order-history-search-bar-input">
                            <fcp-search
                                [formGroup]="searchForm"
                                [placeholder]="getSearchBarPlaceholder() | translate"
                                formControlName="search"
                                (searchQueryChange)="onArticleSearch($event)"
                            ></fcp-search>
                        </section>
                    </form>
                    <section class="fc-order-history-filter" fc-skeleton>
                        <fcp-dropdown-tree
                            *ngIf="isRetailer"
                            [title]="'ORDER_HISTORY_OVERVIEW.BRAND' | translate"
                            searchTitle="{{ 'BRAND_PRODUCTS.SEARCH' | translate }}"
                            [menu]="brandsFilterV2 | async"
                            [isMulti]="true"
                            [allowSearch]="true"
                            (itemSelected)="handleOnSelectBrandFilter($event)"
                            [selectedItemValue]="selectedBrandFilters | async"
                            data-e2e-hook="order-history-filter-brand"
                        >
                        </fcp-dropdown-tree>

                        <fcp-dropdown-tree
                            *ngIf="!isRetailer"
                            [title]="'ORDER_HISTORY_OVERVIEW.ORDER_RETAILER' | translate"
                            searchTitle="{{ 'BRAND_PRODUCTS.SEARCH' | translate }}"
                            [menu]="retailersFilterV2 | async"
                            [isMulti]="true"
                            [allowSearch]="true"
                            (itemSelected)="handleOnSelectRetailerFilter($event)"
                            [selectedItemValue]="selectedRetailersFilters | async"
                        >
                        </fcp-dropdown-tree>
                    </section>

                    <section class="fc-order-history-filter" fc-skeleton>
                        <fcp-dropdown
                            [isMulti]="true"
                            [formGroup]="filterForm"
                            [title]="'ORDER_HISTORY_OVERVIEW.ORDER_TYPE' | translate"
                            [items]="orderTypesFilter | async"
                            formControlName="orderTypes"
                            (close)="handleOnCloseFilter($event, applyOrderTypesFilter)"
                            [disabled]="showOnlyPreorders"
                            data-e2e-hook="order-history-filter-order-type"
                        >
                        </fcp-dropdown>
                    </section>
                </div>
                <div class="fc-order-history-total-items" fc-skeleton>
                    {{ (search | async)?.facets?.count?.total }} {{ 'ORDER_HISTORY_OVERVIEW.ITEMS' | translate }}
                </div>
            </div>
        </form>

        <section class="fc-order-chips" fc-skeleton>
            <ng-container *ngIf="search | async as searchValue">
                <div *ngIf="searchValue.query" class="fc-chip">
                    <fcp-chip
                        [item]="{ text: searchValue.query, value: searchValue.query }"
                        (onRemove)="onRemoveSearchQuery()"
                        [dismissible]="true"
                    >
                    </fcp-chip>
                </div>

                <div
                    class="fc-chip"
                    *ngFor="
                        let brandsFilter of getSelectedFilters(brandsFilter | async, searchValue?.facets?.brands);
                        trackBy: trackByIndex
                    "
                >
                    <fcp-chip
                        [item]="brandsFilter"
                        (onRemove)="onRemoveBrandsFilter(searchValue, $event)"
                        [dismissible]="true"
                    >
                    </fcp-chip>
                </div>

                <div
                    class="fc-chip"
                    *ngFor="
                        let orderTypesFilter of getSelectedFilters(
                            orderTypesFilter | async,
                            searchValue?.facets?.orderTypes
                        );
                        trackBy: trackByIndex
                    "
                >
                    <fcp-chip
                        [item]="orderTypesFilter"
                        (onRemove)="onRemoveOrderTypesFilter(searchValue, $event)"
                        [dismissible]="!(showOnlyPreorders && orderTypesFilter.text === 'Preorder')"
                    >
                    </fcp-chip>
                </div>

                <div
                    class="fc-chip"
                    *ngFor="
                        let retailerFilter of getSelectedFilters(
                            retailersFilter | async,
                            searchValue?.facets?.retailers
                        );
                        trackBy: trackByIndex
                    "
                >
                    <fcp-chip
                        [item]="retailerFilter"
                        (onRemove)="onRemoveRetailersFilter(searchValue, $event)"
                        [dismissible]="true"
                    >
                    </fcp-chip>
                </div>

                <div
                    class="fc-chip"
                    *ngFor="
                        let orderDatesFilter of getSelectedFilters(orderDatesFilter | async, orderDateFacets | async);
                        trackBy: trackByIndex
                    "
                >
                    <fcp-chip
                        [item]="orderDatesFilter"
                        (onRemove)="onRemoveOrderDatesFilter(searchValue, $event)"
                        [dismissible]="true"
                    >
                    </fcp-chip>
                </div>
                <div *ngIf="showClearAll | async" class="fc-product-search-clear-all">
                    <a (click)="resetAllFilters()">{{ 'ORDER.PRODUCT_SEARCH.CLEAR_ALL' | translate }}</a>
                </div>
            </ng-container>
        </section>

        <div *ngIf="(search | async)?.orders.length === 0">
            <hr />
            <h4>{{ 'ORDER_HISTORY_OVERVIEW.NO_ORDERS' | translate }}</h4>
        </div>

        <ng-container *ngLet="displayedColumns | async as displayedColumns">
            <ng-container *ngLet="(search | async)?.orders.length > 0 && (search | async) as search">
                <div
                    *ngIf="search || showSkeleton"
                    fc-skeleton
                    class="fc-order-history-table-wrapper"
                    data-e2e-hook="order-history-list"
                >
                    <table cdk-table [dataSource]="search.orders" class="hover">
                        <ng-container cdkColumnDef="orderNumber">
                            <th cdk-header-cell class="fc-order-history-table-row-order-number" *cdkHeaderCellDef>
                                {{ 'ORDER_HISTORY_OVERVIEW.ORDER_NUMBER' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-order-number">
                                {{ order.orderNumber }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="date">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-date">
                                {{ 'ORDER_HISTORY_OVERVIEW.DATE' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order">
                                <div class="fc-order-history-table-row-date">{{ order.orderPlacedDate | date }}</div>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="brands">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-brands">
                                {{ 'ORDER_HISTORY_OVERVIEW.BRANDS' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-brands">
                                <ng-container *ngLet="getBrandNameBadgesForOrder(order) as brands">
                                    <fcp-badge
                                        class="fc-order-history-badge"
                                        size="medium"
                                        color="neutral"
                                        *ngFor="let brand of brands"
                                        [text]="brand"
                                        [inversed]="true"
                                    ></fcp-badge>
                                </ng-container>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="store">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-store">
                                {{ 'ORDER_HISTORY_OVERVIEW.ORDER_STORE_NAME' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-store">
                                {{ order.retailerOrganization.storeAddress.name }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="retailer">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-retailer">
                                {{ 'ORDER_HISTORY_OVERVIEW.ORDER_RETAILER' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-retailer">
                                {{ order.retailerOrganization.retailerName }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="gln">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-gln">
                                {{ 'ORDER_HISTORY_OVERVIEW.GLN' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order">{{ order.retailerOrganization.gln }}</td>
                        </ng-container>

                        <ng-container cdkColumnDef="type">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-type">
                                {{ 'ORDER_HISTORY_OVERVIEW.TYPE' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-type">
                                <fcp-badge
                                    class="fc-order-history-badge"
                                    size="medium"
                                    color="neutral"
                                    [text]="getOrderTypeName(order.clientType) | translate"
                                    [inversed]="true"
                                ></fcp-badge>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="placedBy">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-placed-by">
                                {{ 'ORDER_HISTORY_OVERVIEW.PLACED_BY' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-placed-by">
                                <a class="fc-order-history-table-row-placed-by-email" *ngIf="showEmailIcon(order)">
                                    <i
                                        class="far fa-envelope fc-order-history-table-row-placed-by-icon"
                                        (click)="redirectToEmail($event, order)"
                                        *ngIf="showEmailIcon(order)"
                                    ></i
                                ></a>
                                {{ order.orderingUser.email || order.orderingUser.userFullName }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="brand">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-brand">
                                {{ 'ORDER_HISTORY_OVERVIEW.BRAND' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-brand">
                                {{ order.brands[0].name }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="articles">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-articles">
                                {{ 'ORDER_HISTORY_OVERVIEW.ORDER_ITEMS' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-articles">
                                {{ totalArticles(order) }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="totalPP">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-total-pp">
                                {{ 'ORDER_HISTORY_OVERVIEW.ORDER_TOTAL' | translate }}
                            </th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-total-pp">
                                {{ getOrderTotalPrice(order) }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th cdk-header-cell *cdkHeaderCellDef class="fc-order-history-table-row-actions">&nbsp;</th>
                            <td cdk-cell *cdkCellDef="let order" class="fc-order-history-table-row-actions">
                                <fcp-menu
                                    menuStyle="subtle"
                                    color="transparent"
                                    variant="outlined"
                                    [list]="getMenuListForOrderMemoized() | async"
                                    (menuItemTriggered)="menuItemTriggered($event, order)"
                                >
                                    <i class="far fa-ellipsis-v fc-ars-stores-overview-table-column-menu-icon"></i>
                                </fcp-menu>
                            </td>
                        </ng-container>

                        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
                        <tr
                            cdk-row
                            *cdkRowDef="let order; columns: displayedColumns"
                            [ngClass]="{ 'nav-enabled': showOrderDetails }"
                            (click)="routeToOrderDetails(order)"
                        ></tr>
                    </table>
                </div>
            </ng-container>
        </ng-container>

        <load-more
            class="fc-order-history-load-more-button"
            *ngIf="!showSkeleton && (search | async)?.nextId"
            [totalItems]="(search | async)?.facets?.count?.total"
            [visibleItems]="(search | async)?.orders.length"
            [itemsLabel]="'ORDER_HISTORY_OVERVIEW.ORDERS'"
            (loadMore)="loadMore()"
        ></load-more>
    </div>
</div>

<fc-download-selection-modal
    [id]="downloadContentModalId"
    [title]="'ORDER_HISTORY_OVERVIEW.DOWNLOAD_CONTENT_MODAL.TITLE' | translate"
    (confirmed)="onDownloadSelectionConfirmed($event)"
>
</fc-download-selection-modal>

<fc-back-to-top-button pageContainerName="fc-main-wrapper-content"></fc-back-to-top-button>

<fc-backdrop *ngIf="showSpinner">
    <img src="assets/img/spinner.svg" class="fa-spin" />
</fc-backdrop>

<fc-download-order-details-modal
    modalId="download-order-details"
    [openModalTrigger]="openDownloadOrderDetailsModal"
    [closeModalTrigger]="closeDownloadOrderDetailsModal"
></fc-download-order-details-modal>

<ng-container *ngLet="downloadContentAlert | async as downloadContentAlert">
    <fcp-snackbar
        *ngIf="downloadContentAlert?.display"
        [type]="downloadContentAlert.type"
        (alertClosed)="closeSnackbar()"
    >
        <span>{{ downloadContentAlert.message | translate: downloadContentAlert.downloadInformation }}</span>
    </fcp-snackbar>
</ng-container>
